import React from 'react'

import { Formik } from 'formik'

import { Button, Col, Form, Row } from '_zari/core'
import Yup from '_zari/validation/_yup'

import * as FormGroups from './formGroups'

export const ValidationSchema = Yup.object().shape({
  codigoPresupuesto: Yup.string().required(),
  importe: Yup.number().min(1).required(),
  _idProyecto: Yup.string().required()
})

const DetallesCabeceraSection = ({ dispatch }) => {
  const inputImporteRef = React.useRef(null)

  const formInitialValues = React.useMemo(() => {
    return {
      codigoPresupuesto: '',
      importe: '',
      _idProyecto: ''
    }
  }, [])

  const onSubmit = React.useCallback(
    (data, { resetForm }) => {
      dispatch({ type: 'agregar', payload: data })

      resetForm({
        values: {
          ...formInitialValues
        },
        isSubmitting: false
      })

      inputImporteRef.current.focus()
    },
    [formInitialValues, dispatch]
  )

  return (
    <>
      <Formik
        initialValues={formInitialValues}
        onSubmit={onSubmit}
        validationSchema={ValidationSchema}
        validateOnBlur={false}
        validateOnChange={false}
      >
        {({ errors, handleChange, handleSubmit, isSubmitting, setFieldValue, touched, values }) => (
          <Form>
            <Row>
              <Col md={3}>
                <FormGroups.ImporteFormGroup
                  innerRef={inputImporteRef}
                  iError={errors.importe}
                  iTouched={touched.importe}
                  fIsSubmitting={isSubmitting}
                />
              </Col>
              <Col md={3}>
                <FormGroups.ProyectoFormGroup
                  iError={errors._idProyecto}
                  iTouched={touched._idProyecto}
                  iValue={values.cuentaContableInfo}
                  handleChange={handleChange}
                  setFieldValue={setFieldValue}
                />
              </Col>
              <Col md={4}>
                <FormGroups.CodigoPresupuestoFormGroup
                  iError={errors.cuentaContable}
                  iTouched={touched.cuentaContable}
                  iValue={values.infoCodigoPresupuesto}
                  setFieldValue={setFieldValue}
                />
              </Col>
              <Col md={2}>
                <Form.Group>
                  <Form.Label text='&ensp;' md={12} />
                  <Col md={12}>
                    <Button id='movimientoPresupuesto-agregar-button' block onClick={handleSubmit}>
                      Agregar
                    </Button>
                  </Col>
                </Form.Group>
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
    </>
  )
}

export default React.memo(DetallesCabeceraSection)
